"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const systems_1 = require("@/store/ducks/systems");
const index_view_1 = __importDefault(require("./index.view"));
const SystemCard = ({ system }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useHistory)();
    const onOpenEditionModal = () => {
        dispatch((0, systems_1.setSystemToBeEdited)(system));
        dispatch((0, systems_1.openEditSystemModal)());
    };
    const systemStatus = react_1.default.useMemo(() => {
        return {
            products: system.products,
            isLoading: system.isLoading,
            errorMessage: system.errorMessage,
        };
    }, [system]);
    const onNavigateToComponentsAssociation = react_1.default.useCallback(() => {
        history.push(`/sites-and-systems/${system.id}`);
    }, []);
    return (react_1.default.createElement(index_view_1.default, { onNavigateToComponentsAssociation: onNavigateToComponentsAssociation, productsList: systemStatus.products, systemName: system.name, onOpenEditionModal: onOpenEditionModal }));
};
exports.default = SystemCard;
